export default [
    '%',
    'KGS',
    'LBS'
];
